import { render, staticRenderFns } from "./GlovoRating.vue?vue&type=template&id=4f326fda&scoped=true"
import script from "./GlovoRating.vue?vue&type=script&lang=js"
export * from "./GlovoRating.vue?vue&type=script&lang=js"
import style0 from "./GlovoRating.vue?vue&type=style&index=0&id=4f326fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f326fda",
  null
  
)

export default component.exports